module.exports = __webpack_public_path__ + "static/media/AC.dc5e2292.svg";